




















import Vue from 'vue'
import Component from 'vue-class-component'
import Confirm from '@/components/Confirm.vue'

@Component({
  components: {
    Confirm
  }
})
export default class CantDeleteHMOModal extends Vue {
}
